import _ from 'lodash';

export const formatReceivedCriteriaToFlat = (criteria = [], { companyId = null } = {}) =>
  (criteria || []).reduce((acc, item) => {
    const { id, expression } = item;

    acc[id] = {
      ..._.omit(item, ['id', 'expression']),
      criteriaId: id,
      expression: expression?.value ?? '',
      userFriendlyExpression: expression?.userFriendly ?? '',
      companyId,
    };

    return acc;
  }, {});
